import React from 'react';
import PropTypes from 'prop-types';
import { t } from '../../../../../modules/infra/i18n';

import OwnerPaymentCardContainer from '../../../../common/ownerPaymentCard/OwnerPaymentCardContainer';
import Invoices from '../../subscription/components/Invoices';
import withOwnerTypeAndId from '../../../../common/hoc/withOwnerTypeAndId';

const BrandPaymentSettings = (props) => (
  <>
    <OwnerPaymentCardContainer
      ownerId={props.ownerId}
      ownerType={props.ownerType}
      wrapperClassName="c-inner-wrapper u-max-width-710 u-mt"
      useInputDisplayStyle
      description={t('settings:brand_payment_settings.description')}
    />
    <Invoices />
  </>
);

BrandPaymentSettings.propTypes = {
  ownerId: PropTypes.string.isRequired,
  ownerType: PropTypes.string.isRequired,
};

export default withOwnerTypeAndId(BrandPaymentSettings);
